/* eslint-disable import/prefer-default-export */
import type { IdentitiesState } from '../default.state'
import {
  createScopeInstance,
  getScopeDisplayName
} from '@src/utils/scope.utils'
import type { AuthState } from '@src/redux/reducers/auth'

export const parseScopeList = (
  data: Partial<IdentitiesState>,
  auth: Partial<AuthState>
) => {
  const { scopeList = [] } = data || {}
  const { singleAccounts, organizations } = auth || {}
  return (scopeList || []).map(item => {
    const scope = createScopeInstance(item?.name || item?.scope).parse({
      singleAccounts,
      organizations
    }).value
    return {
      ...item,
      scope_display_name: getScopeDisplayName(scope)
    }
  })
}
